import { useSelector } from 'react-redux';
import {
  selectAccountId,
  selectDeviceId,
  selectIsOnline,
  selectIsServerUp,
  selectShowSMLPricingModal,
  selectSMLUpgradePrompt,
  selectTourActive,
  selectUserToken,
  selectUserTokenDecoded,
} from './selectors';

export const useUserToken = () => useSelector(selectUserToken);

export const useUserTokenDecoded = () => useSelector(selectUserTokenDecoded);

export const useAccountId = () => useSelector(selectAccountId);

export const useDeviceId = () => useSelector(selectDeviceId);

export const useIsOnline = () => useSelector(selectIsOnline);

export const useIsServerUp = () => useSelector(selectIsServerUp);

export const useShowSMLPricingModal = () => useSelector(selectShowSMLPricingModal);

export const useSMLUpgradePrompt = () => useSelector(selectSMLUpgradePrompt);

/** True while the LaziiBee tour runs. */
export const useTourActive = () => useSelector(selectTourActive);
